import Link from 'next/link';
import { ArrowUpRight } from '@phosphor-icons/react';
import './offer-menu-invitation.css';

export function OfferMenuInvitation() {
  return (
    <section className="offer-menu-invite" aria-labelledby="offer-menu-invite-title">
      <div className="offer-menu-invite-surface" aria-hidden="true" />

      <div className="offer-menu-invite-copy">
        <h2 id="offer-menu-invite-title">
          <span>Ну что,</span>
          <span>за роллами?</span>
        </h2>
        <p>
          Выбирай любимые.
          <br />
          Остальное — за нами.
        </p>
      </div>

      <picture className="offer-menu-invite-character">
        <source media="(max-width: 760px)" srcSet="/storefront/offers-mascot-wave-v1.webp" />
        <img
          src="/storefront/offers-mascot-invite-v1.webp"
          alt=""
          width={1086}
          height={1448}
          loading="lazy"
          decoding="async"
        />
      </picture>

      <Link className="offer-menu-invite-link" href="/#menu">
        <span>Открыть меню</span>
        <ArrowUpRight size={22} weight="bold" aria-hidden="true" />
      </Link>
    </section>
  );
}
